module.exports = __webpack_public_path__ + "media/assets/images/cloudy_later_will_snow-94543dae526efde3bd60dcba3ce0d3b6.png";